<ng-container *ngIf="vm">
  <div (swipeleft)="onSwipeLeft()" (swiperight)="onSwipeRight()" class="carousel-wrapper">
    <div class="container-fluid">
      <div
        [attr.data-testid]="'BasePage.' + vm.type + 'Items'"
        class="row"
        [ngClass]="vm.layout"
        [class.justify-content-center]="alignItemsCenter"
        [style.transform]="'translate3d(' + translateWithOffset + '%, 0, 0)'"
        [class.animating]="animating"
        (transitionend)="onCarouselTransitionEnd()"
      >
        <ng-container *ngIf="showPlaceholder">
          <div *ngFor="let _ of [].constructor(displayedItemsLength)" [className]="'carousel-item'">
            <div [osnSharedAspectRatio]="aspectRatio">
              <osn-shared-shimmer-loading [width]="placeholderSize[0]" [height]="placeholderSize[1]"></osn-shared-shimmer-loading>
            </div>
          </div>
        </ng-container>
        <ng-container [ngSwitch]="vm.type">
          <ng-container *ngSwitchCase="carouselType.TopCarousel">
            <osn-shared-carousel-item
              [className]="'carousel-item top-ten-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              [attr.data-testid]="i === 0 ? 'BasePage.firstTopCarouselItem' : 'BasePage.topCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [ranking]="i + 1"
              [minimumTenthElement]="i > 8"
              [carouselTitle]="carouselTitle"
              [preventHover]="preventHoverPreview$ | async"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
            ></osn-shared-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.RecommendedCarousel">
            <osn-shared-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              [attr.data-testid]="i === 0 ? 'BasePage.firstRecommendedCarouselItem' : 'BasePage.recommendedCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [minimumTenthElement]="i > 8"
              [hideShadow]="true"
              [carouselTitle]="carouselTitle"
              [preventHover]="preventHoverPreview$ | async"
              [replaceUrl]="replaceUrl"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
            ></osn-shared-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.ContinueWatchingCarousel">
            <osn-shared-carousel-item
              data-testid="BasePage.continueWatchingCarouselItem"
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              [attr.data-testid]="i === 0 ? 'BasePage.firstContinueWatchingCarouselItem' : 'BasePage.continueWatchingCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [showProgressBar]="true"
              [playMediaOnClick]="true"
              [showEpisodeNumbers]="true"
              [whiteProgressBar]="whiteProgressBar"
              [carouselTitle]="carouselTitle"
              [showBlur]="true"
              [preventHover]="preventHoverPreview$ | async"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
            ></osn-shared-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.MyListCarousel">
            <osn-shared-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              [attr.data-testid]="i === 0 ? 'BasePage.firstMyListCarouselItem' : 'BasePage.myListCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [carouselTitle]="carouselTitle"
              [preventHover]="preventHoverPreview$ | async"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
            ></osn-shared-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.GenericCarousel">
            <osn-shared-generic-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn"
              [attr.data-testid]="i === 0 ? 'BasePage.firstGenericCarouselItem' : 'BasePage.genericCarouselItem'"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [readonlyMode]="vm.readonlyMode"
            ></osn-shared-generic-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.SeasonBasicCarousel">
            <osn-shared-season-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [preventHover]="preventHoverPreview$ | async"
              [carouselTitle]="carouselTitle"
              [showSeoTitle]="showSeoTitle"
            ></osn-shared-season-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.SeasonCollectionCarousel">
            <osn-shared-season-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [preventHover]="preventHoverPreview$ | async"
              [carouselTitle]="carouselTitle"
              [showSeoTitle]="showSeoTitle"
            ></osn-shared-season-carousel-item>
          </ng-container>
          <ng-container *ngSwitchCase="carouselType.RecommendationCarousel">
            <osn-shared-carousel-item
              [className]="'carousel-item' + (vm.isTop10 ? ' top-ten-item' : '')"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              [attr.data-testid]="i === 0 ? 'BasePage.firstRecommendationCarouselItem' : 'BasePage.recommendationCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [ranking]="vm.isTop10 ? i + 1 : undefined"
              [carouselTitle]="carouselTitle"
              [minimumTenthElement]="i > 8"
              [preventHover]="preventHoverPreview$ | async"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
            ></osn-shared-carousel-item>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <osn-shared-carousel-item
              [className]="'carousel-item'"
              *ngFor="let carouselItem of filteredCarouselItemtoShow; trackBy: trackbyFn; let i = index"
              data-testid="BasePage.basicCarouselItem"
              [attr.data-testid]="i === 0 ? 'BasePage.firstBasicCarouselItem' : 'BasePage.basicCarouselItem'"
              [osnSharedIntersectionMarker]
              [attr.guid]="carouselItem.guid"
              [attr.index]="i"
              [vm]="carouselItem"
              [aspectRatio]="aspectRatio"
              [layout]="vm.layout"
              [carouselTitle]="carouselTitle"
              [preventHover]="preventHoverPreview$ | async"
              [showSeoTitle]="showSeoTitle"
              (imageLoaded)="imageLoaded = true"
              (itemSelect)="onCarouselItemSelect($event)"
              [showEpisodeNumbers]="carouselItem.type === 'season'"
            ></osn-shared-carousel-item>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!(isMobile$ | async) && isCarouselScrollable">
    <div class="swipe-btn-container left">
      <div
        dir="ltr"
        *ngIf="showPagerButtons && isLeftScrollPossible"
        (click)="onLeftArrowClick()"
        class="swipe-btn left"
        [class.show]="isLeftScrollPossible"
      >
        <svg-icon size="md" key="left" class="swipe-icon"></svg-icon>
      </div>
    </div>
    <div class="swipe-btn-container right">
      <div
        dir="ltr"
        *ngIf="showPagerButtons && isRightScrollPossible"
        (click)="onRightArrowClick()"
        class="swipe-btn right"
        [class.show]="isRightScrollPossible"
      >
        <svg-icon size="md" key="right" class="swipe-icon"></svg-icon>
      </div>
    </div>
  </ng-container>
</ng-container>
